<template>
    <div
        class="betaalmethodes"
        style="float: none;margin: 0 auto;width: 156px;position: relative;display: block;"
    >
        <img
            src="https://cdn.cruisereizen.nl/img/template/ideal.png"
            style="height: 10px;float: left;margin-top: 2px;"
        />
        <img
            src="https://cdn.cruisereizen.nl/img/template/paypal-logo.png"
            style="height: 14px;float: left;margin-left: 8px;"
        />
        <img
            src="https://cdn.cruisereizen.nl/img/template/visa2.png"
            style="height: 13px;float: left;margin-left: 8px;"
        />
        <img
            src="https://cdn.cruisereizen.nl/img/template/mastercard2.png"
            style="height: 12px;float: left;margin-left: 8px;"
        />
        <img
            src="https://cdn.cruisereizen.nl/img/template/mistercash.jpg"
            style="height: 12px;float: left;margin-left: 8px;"
        />
    </div>
</template>

<script>
export default {
    name: 'BetaalMethodesHor',
}
</script>

<style scoped></style>
